// extracted by mini-css-extract-plugin
export default {"icon":"SearchBucket_icon__rzFV0","value":"SearchBucket_value__JKrGI","margin":"SearchBucket_margin__WLZ0D","badge":"SearchBucket_badge__KSC8t"};